import { fetchGiftAlternatives } from '../utils/gift-alternatives.es6';
import { safeGTMuaEventsPusher } from '../utils/gtm-utilities.es6';

const GTMDESCRIPTOR = {
    REDEEM: {
        section: '4giftClickOnAcceptGift',
        description: '4gift click on accept gift'
    },
    DISCOVER: {
        section: '4giftDiscoverOurGucciSelection',
        description: '4gift discover our gucci selection'
    }
};

const fourGift = '4gift';

const GtmTrackGiftButton = (descriptor, styleId) => {
    const fourGiftAction = descriptor.description;
    safeGTMuaEventsPusher(`4gift.${descriptor.section}`, fourGift, fourGiftAction, styleId);
    try {
        window.analyticsSdk.tracking.sendEvent({
            name: 'four_gift_event',
            event: {
                category: fourGift,
                action: fourGiftAction,
                label: styleId
            }
        });
    } catch (e) {
        console.error(`Problem with Analytics SDK: unable to track 4gift accept/discover event: ${fourGiftAction}`);
    }
};

const GtmTracking = () => {
    try {
        const params = new URL(document.location).searchParams;
        const fourGiftCodeAfter = params.get('4giftCode');
        localStorage.setItem('fourGiftCodeAfter', fourGiftCodeAfter);
    } catch (e) {
        console.error(`Problem with tracking 4gift code after`);
    }
    const styleId = document.querySelector('[data-module="giftRedeemArea"]').getAttribute('data-style-id');
    const discoverSelectionButton = document.querySelectorAll('.gift-show-alternatives');
    const redeemButtons = document.querySelectorAll('.js-gift-product-redeem');

    discoverSelectionButton.forEach(el => {
        el.addEventListener('click', () => {
            GtmTrackGiftButton(GTMDESCRIPTOR.DISCOVER, styleId);
        });
    });

    redeemButtons.forEach(el => {
        el.addEventListener('click', () => {
            GtmTrackGiftButton(GTMDESCRIPTOR.REDEEM, styleId);
            // 4 gift flow doesn't actually have a cart.
            // So this is more like a 'virtual' add to cart during the gift redemption flow
            try {
                window.analyticsSdk.tracking.sendEvent({
                    name: 'add_to_cart',
                    event: {
                        item_id: styleId,
                        label: styleId,
                        addToCartType: fourGift
                    }
                });
            } catch (e) {
                console.error(`Problem with Analytics SDK: unable to track add_to_cart for 4gift`);
            }
        });
    });
};
// End of Google Analytics

const updateRedeemSku = sku => {
    const redeemButtons = document.querySelectorAll('.js-gift-product-redeem');

    redeemButtons.forEach(el => {
        const hrefRoot = el.getAttribute('data-href');
        el.setAttribute('href', hrefRoot + sku);
    });
};

const toggleGiftAreaVisibility = sizeInput => {
    const redeemButton = document.querySelector('.js-gift-product-redeem');
    const isSizeSelected = sizeInput.selectedIndex !== 0;
    const isDataAvailable = sizeInput.options[sizeInput.selectedIndex].getAttribute('data-available') === 'true';
    const isSizeGiftable = isSizeSelected && isDataAvailable;

    // const noGiftMsg = document.querySelector('.gift-product-redeem-not-giftable');
    const giftNoticeMsg = document.querySelector('.gift-product-redeem-notice');
    giftNoticeMsg.classList.toggle('gift-redeemable', !isSizeSelected || isSizeGiftable);
    giftNoticeMsg.classList.add('shown');

    redeemButton.classList.toggle('hide', isSizeSelected && !isDataAvailable);
};

const giftAlternativesVisibility = discoverOurGiftCatalogDiv => {
    if (document.body.classList.contains('gift')) {
        const RADIX = 10;
        const productPrice = discoverOurGiftCatalogDiv[0].getAttribute('data-product-info');
        const priceFilter = [`price_usd = ${parseInt(productPrice, RADIX)}`];
        fetchGiftAlternatives(priceFilter)
            .then(responseBody => {
                if (responseBody.hits.length > 0) {
                    discoverOurGiftCatalogDiv.forEach(node => node.classList.remove('hide'));
                }
            })
            .catch(e => {
                throw new Error(`Fetching gift alternatives ${e}`);
            });
    }
};

const validateSelectedSize = (sizeInput, contentSelect, event) => {
    const isNoSizeSelected = sizeInput.value === '-1';
    if (isNoSizeSelected) {
        event.preventDefault();

        const noSizeSelectedError = sizeInput.options[0].getAttribute('data-error');

        if (!contentSelect.classList.contains('has-error')) {
            contentSelect.insertAdjacentHTML('afterend', `<span class="error-text" id="size-error">${noSizeSelectedError}</span>`);
        }
        contentSelect.classList.toggle('has-error', isNoSizeSelected);
        sizeInput.classList.toggle('error', isNoSizeSelected);
    }
};

export const load = () => {
    const redeemButtons = document.querySelectorAll('.js-gift-product-redeem');
    const purchaseColumnForm = document.getElementById('product-detail-add-to-shopping-bag-form');
    const sizeInput = purchaseColumnForm.querySelector('[name="size"]');
    const contentSelect = purchaseColumnForm.querySelector('.content-select');
    const discoverOurGiftCatalogDiv = document.querySelectorAll('.discover-our-gift-catalog');

    toggleGiftAreaVisibility(sizeInput);
    updateRedeemSku(sizeInput.value);

    sizeInput.addEventListener('productSizeChanged', () => {
        updateRedeemSku(sizeInput.value);
        toggleGiftAreaVisibility(sizeInput);
    });

    redeemButtons.forEach(el => {
        el.addEventListener('click', event => {
            validateSelectedSize(sizeInput, contentSelect, event);
        });
    });

    giftAlternativesVisibility(discoverOurGiftCatalogDiv);
    GtmTracking();
};
